module.exports = __webpack_public_path__ + "static/media/mm1.943729c2.png";